import Permissions from '@/helpers/lists/browserPermissions';

export default {
  methods: {
    checkMicrophonePermissions() {
      navigator.permissions.query(
        { name: 'microphone' },
      ).then((permissionStatus) => {
        this.$eventBus.$emit('microphone-status', permissionStatus.state);
        permissionStatus.onchange = () => {
          this.$eventBus.$emit('microphone-status', permissionStatus.state);
        };
      });
    },
    microphoneUnavailable() {
      this.$eventBus.$emit('microphone-status', Permissions.DENIED);
    },
  },
};
